import React, { useState } from 'react';
import { ClearDocsVisual } from './ClearDocsVisual';
import { KordisVisual } from './KordisVisual';
import { VendooVisual } from './VendooVisual';
import { BotkeeperVisual } from './BotkeeperVisual';
import type { WorkItem } from '../../../types/work';
type WorkVisualProps = {
  item: WorkItem;
};
export function WorkVisual({
  item
}: WorkVisualProps) {
  const [loaded, setLoaded] = useState(false);
  if (item.image) {
    const fit = item.image.fit ?? 'cover';
    return <div className="absolute inset-0" style={{
      backgroundColor: item.image.background ?? 'rgb(var(--surface))'
    }} data-id="element-432" data-mp="36aujl8kmzr17">
        {/* Loaded eagerly so the image is ready before the card scrolls in; it fades in once decoded instead of popping. */}
        <img src={item.image.src} alt={item.image.alt} loading="eager" decoding="async" onLoad={() => setLoaded(true)} ref={el => {
        if (el?.complete && !loaded) setLoaded(true);
      }} className={`h-full w-full transition-opacity duration-300 ease-out ${loaded ? 'opacity-100' : 'opacity-0'} ${fit === 'contain' ? 'object-contain' : 'object-cover object-left'}`} data-id="element-433" data-mp="2wcdnxyar6o8t" />
      </div>;
  }
  switch (item.variant) {
    case 'cleardocs':
      return <ClearDocsVisual stat={item.stat} data-id="element-434" data-mp="3iwmgeks55d0e" />;
    case 'kordis':
      return <KordisVisual data-id="element-435" data-mp="2v7a3paxlumtc" />;
    case 'vendoo':
      return <VendooVisual stat={item.stat} data-id="element-436" data-mp="2v838w7gx149d" />;
    case 'botkeeper':
      return <BotkeeperVisual stat={item.stat} data-id="element-437" data-mp="2q8qn7q1s638d" />;
    default:
      return null;
  }
}